module.exports = __webpack_public_path__ + "img/afiliate-null.ccbd5891.svg";